import React, { useEffect, useState, useCallback } from 'react';
import './offers.css';
import { useDispatch, useSelector } from 'react-redux';
import { hexToRGBA, isEmpty } from '../../../Utils/utils';
import { Button } from 'antd';


import CouponInput from './CouponInput/CouponInput';
import CouponModal from './CouponModal/CouponModal';
import SuccessModal from './CouponModal/SuccessModal';
import OfferMisMatchModal from './CouponModal/OfferMisMatchModal';
import { ReactComponent as OfferTagIcon } from '../../../assets/Offers/OfferTag.svg';
import { ReactComponent as DiscountModalOpenIcon } from '../../../assets/Offers/discountModalOpenIcon.svg';
import { ReactComponent as CoinIcon } from '../../../assets/Offers/coinIcon.svg';

import {
    applyOffer,
    fetchOffers,
    setAppliedOfferDetails,
    setCouponModal,
    setOfferMisMatchModal,
    setSuccessModal
} from '../../../slices/OfferSlice';

import { getAllPaymentMethods, restorePaymentMethodsFromSession, selectCurrencyCode } from '../../../slices/PaymentSessionDetailsSlice';
import { selectActivePaymentMethod } from '../../../slices/PaymentButtonSlice';
import TranslateText from '../../resuableComponents/TranslateText';
import { removeSelectedIntruments } from '../../../slices/SavedInstrumentSlice';
import {
    offerAppliedEvent,
    offerListSelectedEvent,
    offerRemovedEvent,
} from '../../../Utils/uiAnalytics';


const Offers = () => {
    const dispatch = useDispatch();

    // Redux Selectors
    const {
        appliedOfferDetail,
        couponModal,
        couponSuccessModal,
        showOfferMisMatchModal,
        offerList,
        selectedActivePaymentTab
    } = useSelector((state) => state.offers);

    const sessionDetails = useSelector((state) => state.paymentSessionDetails);
    const currencyCode = useSelector(selectCurrencyCode);
    const activePaymentMethod = useSelector(selectActivePaymentMethod);

    const [appliedCoupon, setAppliedCoupon] = useState(false);
    const baseColor = sessionDetails?.baseColor;
    const sessionToken = sessionDetails?.sessionDetails?.token;
    const paymentDetails = sessionDetails?.sessionDetails?.paymentDetails;
    const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents?.showTotalPaymentSummaryField);
    const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents?.totalPaymentSummaryValue);
    const browserCountry = useSelector((state) => state.paymentSessionDetails?.browserCountry);
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [loader, setLoader] = useState(false);
    const offerApplyLoader = useSelector(state => state.offers.offerApplyLoader);



    // Handle coupon apply/remove
    const handleToggleCoupon = useCallback(
        async (code, isApplied, handleSuccess, handleError) => {
            // All apply/remove buttons (inline card, CouponInput, ExpandableOfferCard)
            // route through here, so both events are reported from this one place.
            if (isApplied) {
                offerRemovedEvent();
                dispatch(setAppliedOfferDetails({}));
                dispatch(removeSelectedIntruments())
                dispatch(restorePaymentMethodsFromSession());

            } else {
                offerAppliedEvent();
                const payload = {
                    offerSearchRequest: {
                        currency: paymentDetails?.money?.currencyCode,
                        minAmount: showTotalPaymentSummaryField ? totalPaymentSummaryValue : paymentDetails?.money?.amount,
                        maxAmount: showTotalPaymentSummaryField ? totalPaymentSummaryValue : paymentDetails?.money?.amount,
                        offers: [code]
                    }
                };
                dispatch(applyOffer({
                    sessionToken, payload, handleSuccess: (data) => {
                        dispatch(
                            getAllPaymentMethods({
                                amount: data?.data?.finalAmount,
                                token: sessionDetails?.sessionDetails?.token,
                                offerId: code, browserTimeZone: browserTimeZone,
                                ...(totalPaymentSummaryValue && { amount: totalPaymentSummaryValue })
                            })
                        );
                        dispatch(removeSelectedIntruments())
                        handleSuccess()
                    }, handleError
                }));
            }
        },
        [dispatch, paymentDetails, sessionToken]
    );

    // Fetch offers on mount
    useEffect(() => {
        if (sessionToken && !isEmpty(paymentDetails)) {
            const payload = {
                type: 'Simple',
                currency: paymentDetails?.money?.currencyCode,
                minAmount: totalPaymentSummaryValue || paymentDetails?.money?.amount,
                maxAmount: totalPaymentSummaryValue || paymentDetails?.money?.amount
            };

            dispatch(fetchOffers({ sessionToken, payload }));
        }
    }, [paymentDetails, sessionToken]);

    // Update applied coupon state
    useEffect(() => {
        if (!isEmpty(appliedOfferDetail)) {
            const currentCode = appliedOfferDetail?.evaluatedOffers?.[0];
            setAppliedCoupon(currentCode || false);
        } else {
            setAppliedCoupon(false);
        }
    }, [appliedOfferDetail]);
    const isDisabled = selectedActivePaymentTab === 5 || activePaymentMethod === 'Emi';

    const couponBackgroundColor = hexToRGBA(baseColor, 0.1);



    const handleClickAction = (code, isActive) => {
        if (!offerApplyLoader) {
            if (!isActive) setLoader(true);

            handleToggleCoupon(code, isActive, () => {
                setTimeout(() => {
                    dispatch(setSuccessModal(true));

                }, 100)
                dispatch(setCouponModal(false));
                setLoader(false)
            });
        }
    };

    return (
        <>
            <div className="offersContainer">
                <div className="deliveryAddressHeader">
                    <div className="headerDiv">
                        <OfferTagIcon style={{ color: "black", height: "20px", width: "20px" }} />
                        <article className="deeliveryHeading dynamic-font-family">
                            <TranslateText label={"DISCOUNT_CODE_TITLE"}>
                                Discount Code
                            </TranslateText>
                        </article>
                    </div>
                    {offerList?.length > 0 && (
                        <article
                            style={{ color: baseColor }}
                            className="viewAllBtn"
                            onClick={() => {
                                offerListSelectedEvent();
                                dispatch(setCouponModal(true));
                            }}>
                            <TranslateText label={"VIEW_ALL_COUPON"}>   View all </TranslateText> <DiscountModalOpenIcon />
                        </article>
                    )}

                </div>
                <div className="couponContainerMain">
                    {!appliedCoupon && offerList?.length == 1 && <>
                        <div className='offerCard' style={{ padding: "8px 10px" }}>
                            <div className="offer-header">
                                <div className="coupon-code" style={{ background: couponBackgroundColor }}>
                                    <OfferTagIcon style={{ color: baseColor }} className="coupon-icon" />
                                    <span className="code-text">{offerList[0].title}</span>
                                </div>
                                <Button
                                    loading={loader}
                                    onClick={() => handleClickAction(offerList[0].code, false)}
                                    style={{
                                        color: baseColor,
                                        cursor: "pointer",
                                        padding: 0,
                                        textTransform: "uppercase"
                                    }}
                                    className="applyBtn active "
                                >
                                    <TranslateText label={"APPLY_COUPON"}>
                                        APPLY
                                    </TranslateText>
                                </Button>
                            </div>
                        </div>
                    </>}

                    <CouponInput
                        showAppliedCoupon
                        appliedCoupon={appliedCoupon}
                        handleToggleCoupon={handleToggleCoupon}
                        baseColor={baseColor}
                    // disabled={isDisabled}
                    />

                    {appliedOfferDetail?.discountAmount > 0 && (
                        <div className="appliedOfferFlag">
                            <CoinIcon style={{ height: '20px' }} />
                            <p>
                                <TranslateText label={"DISCOUNT_YOU_SAVED_TEXT"}>
                                    Yay! You saved
                                </TranslateText>
                                <span className="currency-symbol" style={{ fontWeight: 500 }}> {paymentDetails?.money?.currencyCode} </span> {appliedOfferDetail?.discountAmount}  <TranslateText label={"DISCOUNT_YOU_SAVE_TEXT_2"}> on this order </TranslateText>
                            </p>
                        </div>
                    )}
                </div>
            </div>

            <OfferMisMatchModal
                showModal={showOfferMisMatchModal}
                setShowModal={() => dispatch(setOfferMisMatchModal(false))}
                baseColor={baseColor}
            />

            {couponSuccessModal && (
                <SuccessModal
                    appliedCoupon={appliedCoupon}
                    baseColor={baseColor}
                    showModal={couponSuccessModal}
                    setShowModal={() => dispatch(setSuccessModal(false))}
                />
            )}

            {couponModal && (
                <CouponModal
                    showModal={couponModal}
                    setShowModal={() => dispatch(setCouponModal(false))}
                    baseColor={baseColor}
                    handleToggleCoupon={handleToggleCoupon}
                    appliedCoupon={appliedCoupon}
                />
            )}
        </>
    );
};

export default Offers;
